<template>
  <div class="layout-section layout-section--welcome-bar">
    Hello, {{ email }}
  </div>
</template>

<script>
export default {
  props: ['email'],
};
</script>

<style>
</style>